import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { RegisterForm } from '../components/auth/RegisterForm';
import { Seo } from '../components/Seo';

export const Register: React.FC = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  // Already signed in? No need to register — go to the dashboard.
  useEffect(() => {
    if (!loading && user) {
      navigate('/dashboard', { replace: true });
    }
  }, [user, loading, navigate]);

  if (!loading && user) {
    return null;
  }

  return (
    <>
      <Seo title="Create your account — Local Area Cloud" description="Create a free Local Area Cloud account." path="/register" noindex />
      <RegisterForm />
    </>
  );
};
